import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const payment = {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}
